// extracted by mini-css-extract-plugin
module.exports = {"similarBrands":"SimilarBrands_similarBrands__o1Cqx","brandsList":"SimilarBrands_brandsList__3Z6uN","brand":"SimilarBrands_brand__3MnFa"};